"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _classnames = _interopRequireDefault(require("classnames"));

var SaveCustomViewModal = function SaveCustomViewModal(_ref) {
  var customViewName = _ref.customViewName,
      customViewRadioInput = _ref.customViewRadioInput,
      isCustomView = _ref.isCustomView,
      onClose = _ref.onClose,
      onCustomViewNameChanged = _ref.onCustomViewNameChanged,
      onRadioButtonChanged = _ref.onRadioButtonChanged,
      onSaveCustomView = _ref.onSaveCustomView,
      radioOptions = _ref.radioOptions,
      showModal = _ref.showModal,
      errorMessage = _ref.errorMessage;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: showModal,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Save view",
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, isCustomView && (0, _preact.h)(_RadioInputGroup.default, {
    title: "",
    options: radioOptions,
    onChange: function onChange(option, idx) {
      return onRadioButtonChanged(option, idx);
    },
    value: customViewRadioInput
  }), (0, _preact.h)(_InputGroup.default, {
    error: errorMessage,
    formGroupClasses: (0, _classnames.default)('custom-view-name-input', isCustomView ? ' custom-view-name-input--update' : null),
    onChange: onCustomViewNameChanged,
    placeholder: "Enter custom view name",
    title: isCustomView ? null : 'Custom view name',
    value: customViewName,
    newStyle: true
  })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
    title: "Save view",
    variant: "success",
    onClick: onSaveCustomView,
    className: "qa-save-custom-view",
    newStyle: true,
    size: "medium"
  }), (0, _preact.h)(_buttonControl.default, {
    title: "Cancel",
    onClick: onClose,
    newStyle: true,
    size: "medium"
  })));
};

var _default = SaveCustomViewModal;
exports.default = _default;